import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=ecd8be1a"
import script from "./OAuth.vue?vue&type=script&lang=js"
export * from "./OAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports